import { useLayoutEffect, useState } from 'react';
import { getFocus, useGet } from 'state/jotai';
import { _bootstrap } from 'state/store.bootstrap';
import { active_project } from 'state/store.global';

export const useScalePoint = (bounds, dimensions, mode, isMobile) => {
  const [res, setRes] = useState(0);

  const { pin } = useGet(active_project);
  const projectType = getFocus(_bootstrap, 'type');

  useLayoutEffect(() => {
    if (!bounds.width || !bounds.height) return;

    let scaleFactor = 1;

    // Calculate width/height ratios
    const R_map = (dimensions.W / dimensions.H);
    const R_bounds = (bounds.width / bounds.height);

    // Always scale to cover the bigger side
    scaleFactor = Math.max(bounds.width / dimensions.W, bounds.height / dimensions.H);

    // Optional: special handling for "poly" projects if needed
    if (projectType === 'poly' && pin === 0) {
      // Keep the same logic as above or customize if necessary
      // For now, we just use the cover scaling
      scaleFactor = Math.max(bounds.width / dimensions.W, bounds.height / dimensions.H);
    }

    // Update only if changed
    if (res !== scaleFactor) {
      setRes(scaleFactor);
    }

  }, [bounds, dimensions, projectType, pin, mode, isMobile]); // Include dependencies

  return res || 1; // Default scale factor = 1
};
